import { useState, useEffect } from "react";
import { AxiosResponse } from "axios";

import Navbar from "../Navbar";
import Footer from "../Footer";
import TestimonialsNew from "../TestimonialsNew";
import HeroCTA1 from "../HeroCTA1";
import SimpleStepsAfriPay from "../SimpleStepsAfriPay";
import { DashboardApi } from "../../apis/DashboardApi";
import HeroSection from "../sections/HeroSection";
import LiveRatesTicker from "../sections/LiveRateSticker";
import TrustedByBanner from "../sections/TrustedbyBanner";
import GoLimitlessSection from "../sections/GoLimitlessSection";
import CompareSection from "../sections/CompareSection";
import FaqSection from "../sections/FAQSection";
import NewsSection from "../sections/NewsSection";
import PartnersSection from "../sections/PartnersSection";
import BridgeCTASection from "../sections/BridgeCTASection";


// Global ticker animation (kept here so it's injected once at the page level)
const TICKER_STYLES = `
  @keyframes scroll-rates {
    0%   { transform: translateX(0); }
    100% { transform: translateX(-50%); }
  }
  .rates-ticker {
    animation: scroll-rates 30s linear infinite;
  }
  .rates-ticker:hover {
    animation-play-state: paused;
  }
`;

function HomeV3() {
    const [allRates, setAllRates] = useState<any>(null);

    const fetchAllRates = () => {
        DashboardApi.getAllRatesOnWebsite()
            .then((response: AxiosResponse<any>) => {
                if (response?.data) {
                    setAllRates(response?.data?.data);
                }
            })
            .catch((error) => {
                console.error("Error fetching live rates:", error);
            });
    };

    useEffect(() => {
        fetchAllRates();

        const intervalId = setInterval(fetchAllRates, 30 * 60 * 1000); // refresh every 30 min
        return () => clearInterval(intervalId);
    }, []);

    return (
        <>
            <style>{TICKER_STYLES}</style>

            <Navbar />

            <HeroSection />
            <LiveRatesTicker allRates={allRates} />
            <PartnersSection />

            <GoLimitlessSection />

            <BridgeCTASection />

            {/* Testimonials sit between Go Limitless and Compare */}
            <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
                <TestimonialsNew />
            </div>

            <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
                <CompareSection />
                <SimpleStepsAfriPay />
            </div>

            <FaqSection />
            <NewsSection />

            <div className="max-w-7xl mx-auto mb-6 md:mb-8">
                <HeroCTA1 />
            </div>

            <Footer />
        </>
    );
}

export default HomeV3;